export class DepositInfo {
    paymentMethod: string;
    amountInfo: any;
    nativeCurrency: string;
    bonusInfo: any;
    browserInfo: any;
    amountInAccountCurrency: string = '';
    amountCharged: string;
    paymentAccountInfo: any;
    germanAMLChangesEnabled: boolean;
    isBelgiumRgDecreeEnabled: boolean;
    increaseLimitUrl: string;
    productPreference: string;
    worldPaySessionId: string;
    details: any;
    arcHighVolumeCompleteDeposit: string;
    playPlusCashId: string;
    pageName?: string;
}
export interface RgLimitInfoData {
    rg_first_bucket_threshold: any;
    rg_second_bucket_threshold: any;
    rg_third_bucket_threshold: any;
    increaseLimitUrl: any;
    rglimitInfo?: any[];
}

export interface DepositSubmitRequest {
    paymentMethod: string;
    amountInfo: {
        nativeCurrency: string;
        nativeAmountString: string;
    };
    bonusInfo: {};
    browserInfo?: {
        browserLanguage: string;
        browserScreenHeight: number;
        browserScreenWidth: number;
        browserTimeZone: number;
    };
    germanAMLChangesEnabled?: boolean;
    paymentAccountInfo?: {
        paymentAccountId?: string;
        paymentAccountID?: string;
        ccId?: string;
        emailId?: string;
        freebetCode?: string;
        validationURL?: string;
        billingDescriptor?: string;
        epsPaymentID?: string;
        IBAN?: string;
        SWIFT?: string;
        mobileNumber?: string;
        mobileCountryCode?: string;
        paymethodID?: string;
        cpfNumber?: string;
        voucherNumber?: string;
        bankName?: string;
        payerPassword?: string;
        transactionId?: string;
        providerBonusAmount?: string;
        serialNumber?: string;
        venmo_firstName?: string;
        venmo_lastName?: string;
        venmo_email?: string;
        venmo_phone?: string;
        venmo_nonce?: string;
        venmo_collectedDeviceData?: string;
        venmo_payment_data?: string;
        cardType?: string;
        originalCardEndDigits?: string;
        tempToken?: string;
        isNewRegistration?: string;
        cryptoCurrencyCode?: string;
        rippleValue?: number;
        selectedNetwork?: string;
        returnAddress?: string;
        instrumentId?: string;
        brainTreeDeviceData?: string;
        isBTSDKSuccess?: string;
        deviceFingerPrintSessionId?: string;
        fundingSource?: string;
        telephoneNumber?: string;
        fromTryAgain?: string;
    };
    details?: {
        fundingAmount?: string;
        cvv?: string;
        alertId?: string;
        identityVerificationRequestId?: string;
        identityVerifierRequestId?: string;
        flow?: string;
        type?: string;
        kbaflow?: string;
        GA_SESSION_ID?: string;
        GA_CLIENT_ID?: string;
        user_consent?: string;
    };
    verificationInformation?: VerificationInformation[];
    playPlusCashId?: string;
    productPreference: string;
    worldPaySessionId?: string;
    worldPaySessionIdStatus?: boolean;
    pageName?: string;
    redirectPage?: string;
}
export interface VerificationInformation {
    prompt?: string;
    type?: string;
    userAnswer?: string;
}
